export const GLOBAL_REGION = 'global';
